import React from 'react';

const ConfirmationModal = ({ show, title, message, onConfirm, onCancel, confirmText = 'Confirm', cancelText = 'Cancel', type = 'danger', loading = false }) => {
    if (!show) return null;

    return (
        <>
            <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
                        <div className={`modal-header border-0 p-4 ${type === 'danger' ? 'bg-danger-subtle' : 'bg-primary-subtle'}`}>
                            <div className="d-flex align-items-center gap-3">
                                <div className={`rounded-circle p-2 d-flex align-items-center justify-content-center ${type === 'danger' ? 'bg-danger text-white' : 'bg-primary text-white'}`} style={{ width: '48px', height: '48px' }}>
                                    <i className={`bi ${type === 'danger' ? 'bi-exclamation-triangle-fill' : 'bi-info-circle-fill'} fs-4`}></i>
                                </div>
                                <h5 className="modal-title fw-bold text-dark mb-0">{title}</h5>
                            </div>
                            <button type="button" className="btn-close" onClick={onCancel} aria-label="Close" disabled={loading}></button>
                        </div>
                        <div className="modal-body p-4 text-center">
                            <p className="text-secondary mb-0 fs-5">{message}</p>
                        </div>
                        <div className="modal-footer border-0 p-4 bg-light d-flex justify-content-center gap-3">
                            <button type="button" className="btn btn-light px-4 py-2 fw-bold text-secondary border" onClick={onCancel} disabled={loading}>
                                {cancelText}
                            </button>
                            <button
                                type="button"
                                className={`btn ${type === 'danger' ? 'btn-danger' : 'btn-primary'} px-4 py-2 fw-bold shadow-sm d-flex align-items-center gap-2`}
                                onClick={onConfirm}
                                disabled={loading}
                            >
                                {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                {loading ? 'Processing...' : confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConfirmationModal;
